import ExcelJS from "exceljs";
import {saveAs} from 'file-saver';
import {Notification} from "element-ui";
import moment from "moment/moment";

class ExcelStatisticalSurveyForm {

    /**
     * Phương thức xuất file tổng hợp phiếu khảo sát
     *
     * @param {Object} headerSheet - Thông tin tiêu đề chung sheet
     * @param {String} headerSheet.nameSchool - Tên trường
     * @param {String} headerSheet.nameForm - Tên phiếu khảo sát
     * @param {String} headerSheet.surveyForm - Thời gian áp dụng của phiếu
     * @param {String} headerSheet.nameUserCreate - Người tạo phiếu
     *
     * @param {Array<Object>} questions - Danh sách câu hỏi của phiếu
     * @param {Number} questions.idQuestion - ID câu hỏi
     * @param {String} questions.questionText - Nội dung câu hỏi
     * @param {String} questions.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} questions.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} questions.answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} questions.answerUserApplyList.userApplyResponse - Thông tin người trả lời
     * @param {Number} questions.answerUserApplyList.userApplyResponse.idUser - ID nguời trả lời
     * @param {String} questions.answerUserApplyList.userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} questions.answerUserApplyList.userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} questions.answerUserApplyList.userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} questions.answerUserApplyList.userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} questions.answerUserApplyList.userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} questions.answerUserApplyList.departmentTeacherApplyList.idDepartment - ID phòng
     * @param {String} questions.answerUserApplyList.departmentTeacherApplyList.departmentName - Tên phòng ban
     * @param {String} questions.answerUserApplyList.answerText - Câu trả lời
     *
     * @param {Object} statistical - Một số thông tin khác để thống kê
     * @param {Number} statistical.visit - Số lượng truy cập phiếu
     * @param {Number} statistical.viewers - Số lượng xem phiếu
     * @param {Array<Object>} statistical.listUserApply - Danh sách người áp dụng trả lời phiếu
     * @param {Number} statistical.listUserApply.idUser - id người được áp dụng
     * @param {String} statistical.listUserApply.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} statistical.listUserApply.nameUserApply - Tên người được áp dụng
     * @param {String} statistical.listUserApply.classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} statistical.listUserApply.answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} statistical.listUserApply.departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} statistical.listUserApply.departmentTeacherApplyList.idDepartment - ID phòng ban
     * @param {String} statistical.listUserApply.departmentTeacherApplyList.departmentName - Tên phòng ban
     * */
    async exportExcel(headerSheet, questions, statistical) {
        const workbook = new ExcelJS.Workbook();

        this.configureTemplateSheet(workbook, headerSheet, questions, statistical);

        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            saveAs(blob, `${headerSheet.nameForm} ${moment().format('YYYY-MM-DD_HH_mm_ss')}.xlsx`);
            Notification({
                title: 'Thành công',
                message: 'Xuất file Excel thành công!',
                type: 'success',
                duration: 3000,
            });
        } catch (error) {
            Notification({
                title: 'Lỗi',
                message: 'Lỗi xuất file Excel',
                type: 'warning',
                duration: 3000,
            });
        }
    }

    /**
     * Phương thức tạo câu hỏi cho mỗi sheet
     *
     * @param { ExcelJS.Workbook } workbook
     *
     * @param {Object} headerSheet - Thông tin tiêu đề chung sheet
     * @param {String} headerSheet.nameSchool - Tên trường
     * @param {String} headerSheet.nameForm - Tên phiếu khảo sát
     * @param {String} headerSheet.surveyForm - Thời gian áp dụng của phiếu
     * @param {String} headerSheet.nameUserCreate - Người tạo phiếu
     *
     * @param {Array<{idQuestion: Number, questionText: String, valueQuestion: String, typeQuestion: String, answerUserApplyList: {userApplyResponse: {idUser: Number, typeUser: String, nameUserApply: String, classNameKids: String, answer: Boolean, departmentTeacherApplyList: Array<Object>}, departmentTeacherApplyList: {idDepartment: Number, departmentName: String}, answerText: String}}>} questions - Danh sách câu hỏi của phiếu
     * @param {Number} questions.idQuestion - ID câu hỏi
     * @param {String} questions.questionText - Nội dung câu hỏi
     * @param {String} questions.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} questions.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} questions.answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} questions.answerUserApplyList.userApplyResponse - Thông tin người trả lời
     * @param {Number} questions.answerUserApplyList.userApplyResponse.idUser - ID nguời trả lời
     * @param {String} questions.answerUserApplyList.userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} questions.answerUserApplyList.userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} questions.answerUserApplyList.userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} questions.answerUserApplyList.userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} questions.answerUserApplyList.userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} questions.answerUserApplyList.userApplyResponse.departmentTeacherApplyList.idDepartment - ID phòng
     * @param {String} questions.answerUserApplyList.userApplyResponse.departmentTeacherApplyList.departmentName - Tên phòng ban
     * @param {String} questions.answerUserApplyList.answerText - Câu trả lời
     *
     * @param {Object} statistical - Một số thông tin khác để thống kê
     * @param {Number} statistical.visit - Số lượng truy cập phiếu
     * @param {Number} statistical.viewers - Số lượng xem phiếu
     * @param {Array<Object>} statistical.listUserApply - Danh sách người áp dụng trả lời phiếu
     * @param {Number} statistical.listUserApply.idUser - id người được áp dụng
     * @param {String} statistical.listUserApply.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} statistical.listUserApply.nameUserApply - Tên người được áp dụng
     * @param {String} statistical.listUserApply.classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} statistical.listUserApply.answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} statistical.listUserApply.departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} statistical.listUserApply.departmentTeacherApplyList.idDepartment - ID phòng ban
     * @param {String} statistical.listUserApply.departmentTeacherApplyList.departmentName - Tên phòng ban
     *
     */
    configureTemplateSheet(workbook, headerSheet, questions, statistical) {
        questions.map((item, index) => {
            const worksheet = workbook.addWorksheet(`${index + 1} - ${this.sanitizeWorksheetName(item.questionText)}`);

            this.configureHeaderSheet(worksheet, headerSheet);
            this.configureWidthColumn(worksheet, 2, 50);
            this.configureWidthColumn(worksheet, 3, 20);
            this.configureHeightRow(worksheet, 7, 20);
            this.configureHeightRow(worksheet, 8, 20);

            this.configureRenderQuestion(worksheet, item);

            switch (item.typeQuestion) {
                case "Star":
                    this.configureRenderDataStarQuestion(worksheet, item, statistical.listUserApply);
                    break;
                case "Point":
                    this.configureRenderDataPointQuestion(worksheet, item, statistical.listUserApply);
                    break;
                case "Text":
                    this.configureRenderDataTextQuestion(worksheet, item, statistical.listUserApply);
                    break;
                case "Radio":
                case "CheckBox":
                    this.configureRenderDataChoiceQuestion(worksheet, item, statistical.listUserApply);
                    break;
            }
        })

        this.configureRenderSheetGeneral(workbook, headerSheet, questions, statistical);
    }

    /**
     * Phương thức hiển thị sheet Tổng hợp
     *
     * @param { ExcelJS.Workbook } workbook
     *
     * @param {Object} headerSheet - Thông tin tiêu đề chung sheet
     * @param {String} headerSheet.nameSchool - Tên trường
     * @param {String} headerSheet.nameForm - Tên phiếu khảo sát
     * @param {String} headerSheet.surveyForm - Thời gian áp dụng của phiếu
     * @param {String} headerSheet.nameUserCreate - Người tạo phiếu
     *
     * @param {Array<Object>} questions - Danh sách câu hỏi của phiếu
     * @param {Number} questions[].idQuestion - ID câu hỏi
     * @param {String} questions[].questionText - Nội dung câu hỏi
     * @param {String} questions[].valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} questions[].typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} questions[].answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} questions[].answerUserApplyList[].userApplyResponse - Thông tin người trả lời
     * @param {Number} questions[].answerUserApplyList[].userApplyResponse.idUser - ID nguời trả lời
     * @param {String} questions[].answerUserApplyList[].userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} questions[].answerUserApplyList[].userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} questions[].answerUserApplyList[].userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} questions[].answerUserApplyList[].userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} questions[].answerUserApplyList[].userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} questions[].answerUserApplyList[].departmentTeacherApplyList[].idDepartment - ID phòng
     * @param {String} questions[].answerUserApplyList[].departmentTeacherApplyList[].departmentName - Tên phòng ban
     * @param {String} questions[].answerUserApplyList[].answerText - Câu trả lời
     *
     * @param {Object} statistical - Một số thông tin khác để thống kê
     * @param {Number} statistical.visit - Số lượng truy cập phiếu
     * @param {Number} statistical.viewers - Số lượng xem phiếu
     * @param {Array<Object>} statistical.listUserApply - Danh sách người áp dụng trả lời phiếu
     * @param {Number} statistical.listUserApply[].idUser - id người được áp dụng
     * @param {String} statistical.listUserApply[].typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} statistical.listUserApply[].nameUserApply - Tên người được áp dụng
     * @param {String} statistical.listUserApply[].classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} statistical.listUserApply[].answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} statistical.listUserApply[].departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} statistical.listUserApply[].departmentTeacherApplyList[].idDepartment - ID phòng ban
     * @param {String} statistical.listUserApply[].departmentTeacherApplyList[].departmentName - Tên phòng ban
     * */
    configureRenderSheetGeneral(workbook, headerSheet, questions, statistical) {
        const worksheet = workbook.addWorksheet(`Tổng hợp`);

        this.configureWidthColumn(worksheet, 1, 50);
        this.configureWidthColumn(worksheet, 2, 50);
        this.configureWidthColumn(worksheet, 3, 65);
        this.configureWidthColumn(worksheet, 4, 50);
        this.configureHeightRow(worksheet, 4, 20);
        this.configureHeightRow(worksheet, 5, 20);

        const cellTitle = worksheet.getCell("A1");
        worksheet.mergeCells("A1:C1");
        this.addDataCell(cellTitle, `Tổng hợp`);
        this.configureFontStyleCell(cellTitle, true, true, 18, "#000000");

        this.configureRenderGeneralView(worksheet, statistical.visit, statistical.viewers);
        this.configureRenderGeneralAnswer(worksheet, statistical.listUserApply);
        this.renderDataGeneralQuestion(worksheet, questions, statistical.listUserApply);
    }

    renderDataGeneralQuestion(worksheet, question, apply) {
        let startRow = 7;
        question.forEach((item) => {

            switch (item.typeQuestion) {
                case "CheckBox":
                    startRow = this.renderDataGeneralQuestionCheckbox(worksheet, item, apply, startRow + 2);
                    break;
                case "Radio":
                    startRow = this.renderDataGeneralQuestionRadio(worksheet, item, apply, startRow + 2);
                    break;
                case "Point":
                    startRow = this.renderDataGeneralQuestionPoint(worksheet, item, apply, startRow + 2);
                    break;
                case "Star":
                    startRow = this.renderDataGeneralQuestionStar(worksheet, item, apply, startRow + 2);
                    break;
                case "Text":
                    startRow = this.renderDataGeneralQuestionText(worksheet, item, apply, startRow + 2);
                    break;
            }
        })

        this.configureRenderGeneralUser(worksheet, apply, startRow + 2);
    }

    renderDataGeneralQuestionRadio(worksheet, question, apply, startRow) {
        const valueChoice = question.valueQuestion.split(";");
        const cellHeaderQuestion = worksheet.getCell(`A${startRow}`);
        const valueChoiceUsers = this.getListChoiceUser(question);

        worksheet.mergeCells(`A${startRow}:B${startRow}`);

        cellHeaderQuestion.value = `Câu hỏi: ${question.questionText}`;
        this.configureBorderCell(cellHeaderQuestion, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
        this.configureFontStyleCell(cellHeaderQuestion, true, true, 14, "");
        this.configureAlignmentCell(cellHeaderQuestion, "left", "middle", true);
        this.configureFillCell(cellHeaderQuestion, "pattern", "solid", "#FFFF00");
        this.configureHeightRow(worksheet, startRow, 20);

        valueChoice.map((item, index) => {
            const indexRow = startRow + 1;
            const cell = worksheet.getCell(`A${indexRow + index}`);
            const cellValue = worksheet.getCell(`B${indexRow + index}`);
            this.configureHeightRow(worksheet, indexRow + index, 20);

            cell.value = item;
            this.configureFontStyleCell(cell, true, false, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });

            cellValue.value = this.renderDensityChoice(this.normalizeKey(item), valueChoiceUsers);
            this.configureFontStyleCell(cellValue, true, false, 12, "");
            this.configureAlignmentCell(cellValue, "center", "middle", false);
            this.configureFillCell(cellValue, "pattern", "solid", "");
            this.configureBorderCell(cellValue, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
        })

        return startRow + valueChoice.length + 1;
    }

    renderDataGeneralQuestionCheckbox(worksheet, question, apply, startRow) {
        const valueChoice = question.valueQuestion.split(";");
        const cellHeaderQuestion = worksheet.getCell(`A${startRow}`);
        const valueChoiceUsers = this.getListChoiceUser(question);
        console.log(valueChoiceUsers)
        const columns = [
            {key: "selected", headerText: "Lựa chọn", cell: `A${startRow + 1}`},
            {key: "num_select", headerText: "Số lượt chọn (lần)", cell: `B${startRow + 1}`},
            {key: "percent_select", headerText: "Phần trăm lượt chọn (lượt chọn / tổng số người áp dụng) (%)", cell: `C${startRow + 1}`},
            {key: "density_select", headerText: "Tỷ trọng (lượt chọn / tổng số lượt chọn) (%)", cell: `D${startRow + 1}`},
        ];

        worksheet.mergeCells(`A${startRow}:D${startRow}`);

        cellHeaderQuestion.value = `Câu hỏi: ${question.questionText}`;
        this.configureBorderCell(cellHeaderQuestion, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
        this.configureFontStyleCell(cellHeaderQuestion, true, true, 14, "");
        this.configureAlignmentCell(cellHeaderQuestion, "left", "middle", true);
        this.configureFillCell(cellHeaderQuestion, "pattern", "solid", "#FFFF00");
        this.configureHeightRow(worksheet, startRow, 20);

        columns.forEach((column) => {
            const cell = worksheet.getCell(column.cell);
            cell.value = column.headerText;
            this.configureFontStyleCell(cell, true, true, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#FFFFFF"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
            this.configureHeightRow(worksheet, startRow + 1, 20);
            cell.name = column.key; // Gắn key cho cell
        });

        valueChoice.map((item, index) => {
            const indexRow = startRow + 2;
            const cell = worksheet.getCell(`A${indexRow + index}`);
            const cellCount = worksheet.getCell(`B${indexRow + index}`);
            const cellPercent = worksheet.getCell(`C${indexRow + index}`);
            const cellDensity = worksheet.getCell(`D${indexRow + index}`);

            this.configureHeightRow(worksheet, indexRow + index, 20);

            cell.value = item;
            this.configureFontStyleCell(cell, true, false, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });

            cellCount.value = this.renderCountChoice(this.normalizeKey(item), valueChoiceUsers);
            this.configureFontStyleCell(cellCount, true, false, 12, "");
            this.configureAlignmentCell(cellCount, "center", "middle", false);
            this.configureFillCell(cellCount, "pattern", "solid", "");
            this.configureBorderCell(cellCount, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });

            cellDensity.value = this.renderDensityChoice(this.normalizeKey(item), valueChoiceUsers);
            this.configureFontStyleCell(cellDensity, true, false, 12, "");
            this.configureAlignmentCell(cellDensity, "center", "middle", false);
            this.configureFillCell(cellDensity, "pattern", "solid", "");
            this.configureBorderCell(cellDensity, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });

            cellPercent.value = this.renderPercentChoice(this.normalizeKey(item), valueChoiceUsers, apply);
            this.configureFontStyleCell(cellPercent, true, false, 12, "");
            this.configureAlignmentCell(cellPercent, "center", "middle", false);
            this.configureFillCell(cellPercent, "pattern", "solid", "");
            this.configureBorderCell(cellPercent, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
        })

        const cellTotalChoice = worksheet.getCell(`A${startRow + valueChoice.length + 2}`);
        const cellTotalValue = worksheet.getCell(`B${startRow + valueChoice.length + 2}`);

        cellTotalChoice.value = "Tổng lượt chọn";
        cellTotalValue.value = valueChoiceUsers.length;

        this.configureHeightRow(worksheet, startRow + valueChoice.length + 2, 20);

        this.configureFontStyleCell(cellTotalChoice, true, true, 12, "");
        this.configureAlignmentCell(cellTotalChoice, "center", "middle", false);
        this.configureFillCell(cellTotalChoice, "pattern", "solid", "#C5D9F1");
        this.configureBorderCell(cellTotalChoice, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        this.configureFontStyleCell(cellTotalValue, true, true, 12, "");
        this.configureAlignmentCell(cellTotalValue, "center", "middle", false);
        this.configureFillCell(cellTotalValue, "pattern", "solid", "#C5D9F1");
        this.configureBorderCell(cellTotalValue, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        return startRow + valueChoice.length + 3;
    }

    renderDataGeneralQuestionPoint(worksheet, question, apply, startRow) {

        const cellHeaderQuestion = worksheet.getCell(`A${startRow}`);
        const cellTitle = worksheet.getCell(`A${startRow + 1}`);
        const cellValue = worksheet.getCell(`B${startRow + 1}`);

        this.configureHeightRow(worksheet, startRow, 20);
        this.configureHeightRow(worksheet, startRow + 1, 20);

        worksheet.mergeCells(`A${startRow}:B${startRow}`);

        cellHeaderQuestion.value = `Câu hỏi: ${question.questionText}`;
        this.configureBorderCell(cellHeaderQuestion, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
        this.configureFontStyleCell(cellHeaderQuestion, true, true, 14, "");
        this.configureAlignmentCell(cellHeaderQuestion, "left", "middle", true);
        this.configureFillCell(cellHeaderQuestion, "pattern", "solid", "#FFFF00");

        cellTitle.value = "Điểm";
        this.configureFontStyleCell(cellTitle, true, false, 12, "");
        this.configureAlignmentCell(cellTitle, "center", "middle", false);
        this.configureFillCell(cellTitle, "pattern", "solid", "#B7DEE8");
        this.configureBorderCell(cellTitle, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        cellValue.value = this.average(question) + "/10";
        this.configureFontStyleCell(cellValue, true, false, 12, "");
        this.configureAlignmentCell(cellValue, "center", "middle", false);
        this.configureBorderCell(cellValue, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        return startRow + 2;
    }

    renderDataGeneralQuestionStar(worksheet, question, apply, startRow) {
        const cellHeaderQuestion = worksheet.getCell(`A${startRow}`);
        const cellTitle = worksheet.getCell(`A${startRow + 1}`);
        const cellValue = worksheet.getCell(`B${startRow + 1}`);

        this.configureHeightRow(worksheet, startRow, 20);
        this.configureHeightRow(worksheet, startRow + 1, 20);

        worksheet.mergeCells(`A${startRow}:B${startRow}`);

        cellHeaderQuestion.value = `Câu hỏi: ${question.questionText}`;
        this.configureBorderCell(cellHeaderQuestion, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
        this.configureFontStyleCell(cellHeaderQuestion, true, true, 14, "");
        this.configureAlignmentCell(cellHeaderQuestion, "left", "middle", true);
        this.configureFillCell(cellHeaderQuestion, "pattern", "solid", "#FFFF00");

        cellTitle.value = "Đánh giá";
        this.configureFontStyleCell(cellTitle, true, false, 12, "");
        this.configureAlignmentCell(cellTitle, "center", "middle", false);
        this.configureFillCell(cellTitle, "pattern", "solid", "#B7DEE8");
        this.configureBorderCell(cellTitle, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        cellValue.value = this.average(question) + "/5★";
        this.configureFontStyleCell(cellValue, true, false, 12, "");
        this.configureAlignmentCell(cellValue, "center", "middle", false);
        this.configureBorderCell(cellValue, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        return startRow + 2;
    }

    renderDataGeneralQuestionText(worksheet, question, apply, startRow) {
        const data = this.formatDataGeneralAnswerQuestionText(apply, question.answerUserApplyList);
        const cellHeaderQuestion = worksheet.getCell(`A${startRow}`);
        const columns = [
            {key: "name", headerText: "Họ và tên", cell: `A${startRow + 1}`},
            {key: "type", headerText: "Nhân sự / Học sinh", cell: `B${startRow + 1}`},
            {key: "answer", headerText: "Trả lời", cell: `C${startRow + 1}`},
        ];

        this.configureHeightRow(worksheet, startRow, 20);
        worksheet.mergeCells(`A${startRow}:C${startRow}`);

        cellHeaderQuestion.value = `Câu hỏi: ${question.questionText}`;
        this.configureBorderCell(cellHeaderQuestion, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
        this.configureFontStyleCell(cellHeaderQuestion, true, true, 14, "");
        this.configureAlignmentCell(cellHeaderQuestion, "left", "middle", true);
        this.configureFillCell(cellHeaderQuestion, "pattern", "solid", "#FFFF00");

        columns.forEach((column) => {
            const cell = worksheet.getCell(column.cell);
            cell.value = column.headerText;
            this.configureFontStyleCell(cell, true, false, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#FFFFFF"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
            this.configureHeightRow(worksheet, startRow + 1, 20);
            cell.name = column.key; // Gắn key cho cell
        });

        data.forEach((item, rowIndex) => {
            const rowNumber = startRow + 2 + rowIndex;

            worksheet.getCell(`A${rowNumber}`).value = item.name;
            worksheet.getCell(`B${rowNumber}`).value = item.type === "kids" ? "Học sinh" : "Nhân sự";
            worksheet.getCell(`C${rowNumber}`).value = item.answer;

            // Tuỳ chỉnh style cho các cell trong dữ liệu
            ['A', 'B', 'C'].forEach((col) => {
                const cell = worksheet.getCell(`${col}${rowNumber}`);
                this.configureHeightRow(worksheet, rowNumber, 20);
                if (col === "A") {
                    this.configureDataCellName(cell);
                } else {
                    this.configureDataCell(cell);
                }
            });
        });

        return startRow + data.length + 2;

    }

    average(question) {
        let sumPoint = 0;

        question.answerUserApplyList.map((item) => {
            sumPoint += parseFloat(item.answerText);
        })

        if (sumPoint === 0) {
            return "0";
        } else {
            return parseFloat((sumPoint / question.answerUserApplyList.length).toFixed(1));
        }
    }

    renderDensityChoice(choice, listChoiceUsers) {
        const count = listChoiceUsers.filter(item => this.normalizeKey(item) === choice).length;

        if (count === 0) {
            return "0%";
        } else {
            return ((count / listChoiceUsers.length) * 100).toFixed(1) + "%";
        }
    }

    renderPercentChoice(choice, listChoiceUsers, apply) {
        const count = listChoiceUsers.filter(item => this.normalizeKey(item) === choice).length;

        if (count === 0) {
            return "0%";
        } else {
            return ((count / apply.length) * 100).toFixed(1) + "%";
        }
    }

    renderCountChoice(choice, listChoiceUsers) {
        return listChoiceUsers.filter(item => this.normalizeKey(item) === choice).length;
    }

    getListChoiceUser(question) {

        const listChoiceUsers = [];

        question.answerUserApplyList.forEach(item => {
            const listChoice = item.answerText.split(";").filter(choice => choice.trim() !== "");
            listChoiceUsers.push(...listChoice); // Thêm tất cả phần tử của listChoice vào listChoiceUsers
        });

        console.log(listChoiceUsers)
        return listChoiceUsers; // Trả về mảng đã tổng hợp
    }

    configureRenderGeneralUser(worksheet, apply, startRow) {
        const dataAnswer = [];
        const dataUnAnswer = [];
        apply.map(item => {
            if (item.answer) {
                dataAnswer.push(item);
            } else {
                dataUnAnswer.push(item);
            }
        })

        const columns = [
            {key: "answer", headerText: "Danh sách đã trả lời", cell: `A${startRow}`},
            {key: "type_answer", headerText: "Nhân sự / Học sinh", cell: `B${startRow}`},
            {key: "un_answer", headerText: "Danh sách chưa trả lời", cell: `C${startRow}`},
            {key: "type_un_answer", headerText: "Nhân sự / Học sinh", cell: `D${startRow}`},
        ];

        columns.forEach(column => {
            const cell = worksheet.getCell(column.cell);
            cell.value = column.headerText;
            this.configureFontStyleCell(cell, true, false, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
            this.configureHeightRow(worksheet, startRow, 20);
            cell.name = column.key; // Gắn key cho cell
        });

        this.renderDataGeneralSectionAnswer(worksheet, dataAnswer, dataUnAnswer, startRow + 1);
    }

    renderDataGeneralSectionAnswer(worksheet, answers, unAnswers, startRow) {
        if (answers.length >= unAnswers.length) {
            for (let i = 0; i < answers.length; i++) {
                const cellAnswer = worksheet.getCell(`A${startRow + i}`);
                const cellTypeAnswer = worksheet.getCell(`B${startRow + i}`);
                const cellUnAnswer = worksheet.getCell(`C${startRow + i}`);
                const cellTypeUnAnswer = worksheet.getCell(`D${startRow + i}`);

                cellAnswer.value = answers[i].nameUserApply;
                cellTypeAnswer.value = answers[i].typeUser === "kids" ? "Học sinh" : "Nhân sự";
                this.configureFontStyleCell(cellAnswer, false, false, 12, "");
                this.configureHeightRow(worksheet, startRow + i, 20);
                this.configureDataCellName(cellAnswer);

                this.configureFontStyleCell(cellTypeAnswer, false, false, 12, "");
                this.configureDataCell(cellTypeAnswer);

                if (i <= unAnswers.length - 1) {
                    cellUnAnswer.value = unAnswers[i].nameUserApply;
                    cellTypeUnAnswer.value = unAnswers[i].typeUser === "kids" ? "Học sinh" : "Nhân sự";
                }
                this.configureFontStyleCell(cellUnAnswer, false, false, 12, "");
                this.configureHeightRow(worksheet, startRow + i, 20);
                this.configureDataCellName(cellUnAnswer);

                this.configureFontStyleCell(cellTypeUnAnswer, false, false, 12, "");
                this.configureDataCell(cellTypeUnAnswer);
            }
        } else {
            for (let i = 0; i < unAnswers.length; i++) {
                const cellAnswer = worksheet.getCell(`A${startRow + i}`);
                const cellTypeAnswer = worksheet.getCell(`B${startRow + i}`);
                const cellUnAnswer = worksheet.getCell(`C${startRow + i}`);
                const cellTypeUnAnswer = worksheet.getCell(`D${startRow + i}`);

                if (i <= answers.length - 1) {
                    cellAnswer.value = answers[i].nameUserApply;
                    cellTypeAnswer.value = answers[i].typeUser === "kids" ? "Học sinh" : "Nhân sự";
                }
                this.configureFontStyleCell(cellAnswer, false, false, 12, "");
                this.configureHeightRow(worksheet, startRow + i, 20);
                this.configureDataCellName(cellAnswer);

                this.configureFontStyleCell(cellTypeAnswer, false, false, 12, "");
                this.configureDataCell(cellTypeAnswer);

                cellUnAnswer.value = unAnswers[i].nameUserApply;
                cellTypeUnAnswer.value = unAnswers[i].typeUser === "kids" ? "Học sinh" : "Nhân sự";

                this.configureFontStyleCell(cellUnAnswer, false, false, 12, "");
                this.configureHeightRow(worksheet, startRow + i, 20);
                this.configureDataCellName(cellUnAnswer);

                this.configureFontStyleCell(cellTypeUnAnswer, false, false, 12, "");
                this.configureDataCell(cellTypeUnAnswer);
            }
        }
    }

    configureRenderGeneralView(worksheet, visit, viewers) {
        const rows = [
            {key: "visit", headerText: `Lượt truy cập: ${visit}`, cell: "A4"},
            {key: "viewer", headerText: `Lượt xem: ${viewers}`, cell: "A5"},
        ]

        rows.forEach(row => {
            const cell = worksheet.getCell(row.cell);
            cell.value = row.headerText;
            this.configureFontStyleCell(cell, true, false, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
            cell.name = row.key; // Gắn key cho cell
        })
    }

    configureRenderGeneralAnswer(worksheet, apply) {
        const rows = [
            {key: "visit", headerText: `Tỉ lệ trả lời: ${this.calculatePercentageAnswer(apply).percentTrue}`, cell: "B4"},
            {key: "viewer", headerText: `Tỉ lệ chưa trả lời: ${this.calculatePercentageAnswer(apply).percentFalse}`, cell: "B5"},
        ]

        rows.forEach(row => {
            const cell = worksheet.getCell(row.cell);
            cell.value = row.headerText;
            this.configureFontStyleCell(cell, true, false, 12, "");
            this.configureAlignmentCell(cell, "center", "middle", false);
            this.configureFillCell(cell, "pattern", "solid", "");
            this.configureBorderCell(cell, {
                top: {style: "thin", color: "#000000"},
                left: {style: "thin", color: "#000000"},
                bottom: {style: "thin", color: "#000000"},
                right: {style: "thin", color: "#000000"}
            });
            cell.name = row.key; // Gắn key cho cell
        })
    }

    calculatePercentageAnswer(apply) {
        // Đếm số lượng `true` và `false`
        const total = apply.length;
        const countTrue = apply.filter(item => item.answer === true).length;
        const countFalse = total - countTrue; // Tổng trừ đi số `true` sẽ ra số `false`

        // Tính tỷ lệ phần trăm
        const percentTrue = (countTrue / total) * 100;
        const percentFalse = (countFalse / total) * 100;

        return {
            percentTrue: percentTrue.toFixed(1) + '%',
            percentFalse: percentFalse.toFixed(1) + '%',
        };
    }

    /**
     * Phương thức hiển thị kết quả câu trả lời loại Checkbox hoặc Radio
     *
     * @param { ExcelJS.Worksheet } worksheet
     * @param { Object } question - Câu hỏi của phiếu
     * @param {Number} question.idQuestion - ID câu hỏi
     * @param {String} question.questionText - Nội dung câu hỏi
     * @param {String} question.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} question.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} question.answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} question.answerUserApplyList[].userApplyResponse - Thông tin người trả lời
     * @param {Number} question.answerUserApplyList[].userApplyResponse.idUser - ID nguời trả lời
     * @param {String} question.answerUserApplyList[].userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} question.answerUserApplyList[].userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} question.answerUserApplyList[].userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} question.answerUserApplyList[].userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList[].idDepartment - ID phòng
     * @param {String} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList[].departmentName - Tên phòng ban
     * @param {String} question.answerUserApplyList[].answerText - Câu trả lời
     *
     * @param { Array<Object> } apply - Danh sách áp dụng trả lời
     * @param {Number} apply[].idUser - id người được áp dụng
     * @param {String} apply[].typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} apply[].nameUserApply - Tên người được áp dụng
     * @param {String} apply[].classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} apply[].answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} apply[].departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} apply[].departmentTeacherApplyList[].idDepartment - ID phòng ban
     * @param {String} apply[].departmentTeacherApplyList[].departmentName - Tên phòng ban
     */
    configureRenderDataChoiceQuestion(worksheet, question, apply) {
        const data = this.formatDataUserAnswerQuestionChoice(apply, question.answerUserApplyList);

        const valueQuestion = question.valueQuestion.split(";").map((item, index) => ({
            value: item,
            key: item, // Gắn key cho từng lựa chọn
            colIndex: 4 + index
        }));

        // Định nghĩa các cột header và key tương ứng
        const columns = [
            {key: "index", headerText: "STT", cellRange: "A10:A11"},
            {key: "name", headerText: "Họ và tên", cellRange: "B10:B11"},
            {key: "type", headerText: "Nhân sự / Học sinh", cellRange: "C10:C11"},
            {
                key: "choices",
                headerText: "Lựa chọn",
                cellRange: `D10:${String.fromCharCode(68 + valueQuestion.length - 1)}10`
            }
        ];

        // Tạo ánh xạ key -> column index
        const columnMap = columns.reduce((map, col, index) => {
            map[col.key] = index + 1; // Cột Excel bắt đầu từ 1
            return map;
        }, {});

        // Thêm các cột của valueQuestion vào map
        valueQuestion.forEach(({key, colIndex}) => {
            columnMap[key] = colIndex;
        });

        // Configure headers with keys
        columns.forEach((column, index) => {
            const cell = worksheet.getCell(column.cellRange.split(":")[0]); // Lấy ô đầu tiên trong range
            this.configureHeaderCell(cell, index, columns.length - 1, column.headerText);
            this.configureHeightRow(worksheet, 10 + index, 20);
            cell.name = column.key; // Gắn key cho cell

            if (column.cellRange.includes(":")) worksheet.mergeCells(column.cellRange); // Merge nếu cần
        });

        // Configure value questions with keys
        valueQuestion.forEach(({value, key, colIndex}, index) => {
            const cell = worksheet.getCell(11, colIndex);
            cell.value = value;
            cell.name = key; // Gắn key cho cell
            worksheet.getColumn(colIndex).width = 30;
            this.configureChoiceCell(cell, index, valueQuestion.length - 1);
        });

        data.forEach((rowData, rowIndex) => {
            const rowNumber = 12 + rowIndex; // Hàng bắt đầu điền dữ liệu (hàng 9)

            // Điền dữ liệu cơ bản
            Object.keys(columnMap).forEach((key) => {
                const colIndex = columnMap[key]; // Lấy cột tương ứng
                const cell = worksheet.getCell(rowNumber, colIndex);
                const value = rowData[key]; // Giá trị của key trong dữ liệu
                cell.value = value !== undefined ? value : ""; // Điền giá trị hoặc để trống
                if (key === "name") {
                    this.configureDataCellName(cell);
                } else {
                    this.configureDataCell(cell); // Cấu hình style cell
                }
            });

            // Điền dữ liệu tùy chọn (khớp với `valueQuestion`)
            valueQuestion.forEach(({key, colIndex}) => {
                const cell = worksheet.getCell(rowNumber, colIndex);
                const value = rowData[this.normalizeKey(key)]; // Kiểm tra nếu dữ liệu có chứa key tùy chọn

                cell.value = value !== undefined ? value : ""; // Điền giá trị hoặc để trống
                this.configureDataCell(cell); // Cấu hình style cell
            });

            this.configureHeightRow(worksheet, rowNumber, 20);
        });
    }

    /**
     * Phương thức hiển thị kết quả câu trả lời loại văn bản ( Text )
     *
     * @param { ExcelJS.Worksheet } worksheet
     * @param { Object } question - Câu hỏi của phiếu
     * @param {Number} question.idQuestion - ID câu hỏi
     * @param {String} question.questionText - Nội dung câu hỏi
     * @param {String} question.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} question.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} question.answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} question.answerUserApplyList[].userApplyResponse - Thông tin người trả lời
     * @param {Number} question.answerUserApplyList[].userApplyResponse.idUser - ID nguời trả lời
     * @param {String} question.answerUserApplyList[].userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} question.answerUserApplyList[].userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} question.answerUserApplyList[].userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} question.answerUserApplyList[].userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList[].idDepartment - ID phòng
     * @param {String} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList[].departmentName - Tên phòng ban
     * @param {String} question.answerUserApplyList[].answerText - Câu trả lời
     *
     * @param { Array<Object> } apply - Danh sách áp dụng trả lời
     * @param {Number} apply[].idUser - id người được áp dụng
     * @param {String} apply[].typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} apply[].nameUserApply - Tên người được áp dụng
     * @param {String} apply[].classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} apply[].answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} apply[].departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} apply[].departmentTeacherApplyList[].idDepartment - ID phòng ban
     * @param {String} apply[].departmentTeacherApplyList[].departmentName - Tên phòng ban
     */
    configureRenderDataTextQuestion(worksheet, question, apply) {
        const data = this.formatDataUserAnswerQuestionText(apply, question.answerUserApplyList);

        this.configureWidthColumn(worksheet, 4, 100);
        // Định nghĩa các cột header và key tương ứng
        const columns = [
            {key: "index", headerText: "STT", cell: "A10"},
            {key: "name", headerText: "Họ và tên", cell: "B10"},
            {key: "type", headerText: "Nhân sự / Học sinh", cell: "C10"},
            {key: "answer", headerText: "Trả lời", cell: "D10"},
        ];

        columns.forEach((column, index) => {
            const cell = worksheet.getCell(column.cell); // Lấy ô đầu tiên trong range
            this.configureHeaderCell(cell, index, columns.length - 1, column.headerText);
            this.configureHeightRow(worksheet, 10, 20);
            cell.name = column.key; // Gắn key cho cell
        });

        data.forEach((item, rowIndex) => {
            const rowNumber = 11 + rowIndex; // Bắt đầu từ hàng 11

            worksheet.getCell(`A${rowNumber}`).value = item.index;
            worksheet.getCell(`B${rowNumber}`).value = item.name;
            worksheet.getCell(`C${rowNumber}`).value = item.type;
            worksheet.getCell(`D${rowNumber}`).value = item.answer;

            // Tuỳ chỉnh style cho các cell trong dữ liệu
            ['A', 'B', 'C', 'D'].forEach((col) => {
                const cell = worksheet.getCell(`${col}${rowNumber}`);
                this.configureHeightRow(worksheet, rowNumber, 20);
                if (col === "B") {
                    this.configureDataCellName(cell);
                } else {
                    this.configureDataCell(cell);
                }
            });
        });

    }

    /**
     * Phương thức hiển thị kết quả câu trả lời loại điểm ( Point )
     *
     * @param { ExcelJS.Worksheet } worksheet
     * @param { Object } question - Câu hỏi của phiếu
     * @param {Number} question.idQuestion - ID câu hỏi
     * @param {String} question.questionText - Nội dung câu hỏi
     * @param {String} question.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} question.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} question.answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} question.answerUserApplyList[].userApplyResponse - Thông tin người trả lời
     * @param {Number} question.answerUserApplyList[].userApplyResponse.idUser - ID nguời trả lời
     * @param {String} question.answerUserApplyList[].userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} question.answerUserApplyList[].userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} question.answerUserApplyList[].userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} question.answerUserApplyList[].userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList[].idDepartment - ID phòng
     * @param {String} question.answerUserApplyList[].userApplyResponse.departmentTeacherApplyList[].departmentName - Tên phòng ban
     * @param {String} question.answerUserApplyList[].answerText - Câu trả lời
     *
     * @param { Array<Object> } apply - Danh sách áp dụng trả lời
     * @param {Number} apply[].idUser - id người được áp dụng
     * @param {String} apply[].typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} apply[].nameUserApply - Tên người được áp dụng
     * @param {String} apply[].classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} apply[].answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} apply[].departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} apply[].departmentTeacherApplyList[].idDepartment - ID phòng ban
     * @param {String} apply[].departmentTeacherApplyList[].departmentName - Tên phòng ban
     */
    configureRenderDataPointQuestion(worksheet, question, apply) {
        const data = this.formatDataUserAnswerQuestionPoint(apply, question.answerUserApplyList);
        this.configureWidthColumn(worksheet, 4, 30);

        const columns = [
            {key: "index", headerText: "STT", cell: "A10"},
            {key: "name", headerText: "Họ và tên", cell: "B10"},
            {key: "type", headerText: "Nhân sự / Học sinh", cell: "C10"},
            {key: "point", headerText: "Điểm", cell: "D10"},
        ];

        columns.forEach((column, index) => {
            const cell = worksheet.getCell(column.cell); // Lấy ô đầu tiên trong range
            this.configureHeaderCell(cell, index, columns.length - 1, column.headerText);
            this.configureHeightRow(worksheet, 10, 20);
            cell.name = column.key; // Gắn key cho cell
        });

        data.forEach((item, rowIndex) => {
            const rowNumber = 11 + rowIndex; // Bắt đầu từ hàng 11

            worksheet.getCell(`A${rowNumber}`).value = item.index;
            worksheet.getCell(`B${rowNumber}`).value = item.name;
            worksheet.getCell(`C${rowNumber}`).value = item.type;
            worksheet.getCell(`D${rowNumber}`).value = item.point;

            // Tuỳ chỉnh style cho các cell trong dữ liệu
            ['A', 'B', 'C', 'D'].forEach((col) => {
                const cell = worksheet.getCell(`${col}${rowNumber}`);
                this.configureHeightRow(worksheet, rowNumber, 20);
                if (col === "B") {
                    this.configureDataCellName(cell);
                } else {
                    this.configureDataCell(cell);
                }
            });
        });
    }

    /**
     * Phương thức hiển thịc kết quả câu tả lời loại đánh giá ( Star )
     *
     * @param { ExcelJS.Worksheet } worksheet
     * @param { Object } question - Câu hỏi của phiếu
     * @param {Number} question.idQuestion - ID câu hỏi
     * @param {String} question.questionText - Nội dung câu hỏi
     * @param {String} question.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} question.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} question.answerUserApplyList - Danh sách trả lời câu hỏi
     * @param {Object} question.answerUserApplyList.userApplyResponse - Thông tin người trả lời
     * @param {Number} question.answerUserApplyList.userApplyResponse.idUser - ID nguời trả lời
     * @param {String} question.answerUserApplyList.userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} question.answerUserApplyList.userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} question.answerUserApplyList.userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} question.answerUserApplyList.userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} question.answerUserApplyList.userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} question.answerUserApplyList.userApplyResponse.departmentTeacherApplyList.idDepartment - ID phòng
     * @param {String} question.answerUserApplyList.userApplyResponse.departmentTeacherApplyList.departmentName - Tên phòng ban
     * @param {String} question.answerUserApplyList.answerText - Câu trả lời
     *
     * @param { Array<Object> } apply - Danh sách áp dụng trả lời
     * @param {Number} apply.idUser - id người được áp dụng
     * @param {String} apply.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} apply.nameUserApply - Tên người được áp dụng
     * @param {String} apply.classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} apply.answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} apply.departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} apply.departmentTeacherApplyList.idDepartment - ID phòng ban
     * @param {String} apply.departmentTeacherApplyList.departmentName - Tên phòng ban
     */
    configureRenderDataStarQuestion(worksheet, question, apply) {
        const data = this.formatDataUserAnswerQuestionStar(apply, question.answerUserApplyList);

        this.configureWidthColumn(worksheet, 4, 30);

        const columns = [
            {key: "index", headerText: "STT", cell: "A10"},
            {key: "name", headerText: "Họ và tên", cell: "B10"},
            {key: "type", headerText: "Nhân sự / Học sinh", cell: "C10"},
            {key: "star", headerText: "Đánh giá", cell: "D10"},
        ];

        columns.forEach((column, index) => {
            const cell = worksheet.getCell(column.cell); // Lấy ô đầu tiên trong range
            this.configureHeaderCell(cell, index, columns.length - 1, column.headerText);
            this.configureHeightRow(worksheet, 10, 20);
            this.configureHeightRow(worksheet, 11 + data.length, 20);
            cell.name = column.key; // Gắn key cho cell
        });

        data.forEach((item, rowIndex) => {
            const rowNumber = 11 + rowIndex; // Bắt đầu từ hàng 11

            worksheet.getCell(`A${rowNumber}`).value = item.index;
            worksheet.getCell(`B${rowNumber}`).value = item.name;
            worksheet.getCell(`C${rowNumber}`).value = item.type;
            worksheet.getCell(`D${rowNumber}`).value = item.star;


            // Tuỳ chỉnh style cho các cell trong dữ liệu
            ['A', 'B', 'C'].forEach((col) => {
                const cell = worksheet.getCell(`${col}${rowNumber}`);
                this.configureHeightRow(worksheet, rowNumber, 20);
                if (col === "B") {
                    this.configureDataCellName(cell);
                } else {
                    this.configureDataCell(cell);
                }
            });
        });

        worksheet.getColumn(4).eachCell((cell, rowNumber) => { // 'D' là cột thứ 4
            if (rowNumber >= 11) { // Chỉ áp dụng cho hàng dữ liệu
                this.configureFontStyleCell(cell, false, false, 20, "#FFD700");
                this.configureAlignmentCell(cell, "center", "middle", false);
                this.configureBorderCell(cell, {
                    top: {style: "thin", color: "#000000"},
                    left: {style: "thin", color: "#000000"},
                    bottom: {style: "thin", color: "#000000"},
                    right: {style: "thin", color: "#000000"}
                });
            }
        });

        worksheet.mergeCells(`B${11 + data.length}:C${11 + data.length}`);
        const cellTotal = worksheet.getCell(`B${11 + data.length}`);
        const cellValueTotal= worksheet.getCell(`D${11 + data.length}`);
        const cellVoid = worksheet.getCell(`A${11 + data.length}`);

        cellTotal.value = "Trung bình";
        cellValueTotal.value = this.average(question) + "/5★";

        this.configureFillCell(cellVoid, "pattern", "solid", "#C5D9F1");
        this.configureBorderCell(cellVoid, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
        });

        this.configureFillCell(cellTotal, "pattern", "solid", "#C5D9F1");
        this.configureAlignmentCell(cellTotal, "left", "middle", false);
        this.configureFontStyleCell(cellTotal, true, true, 12, "");
        this.configureBorderCell(cellTotal, {
            top: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });

        this.configureFillCell(cellValueTotal, "pattern", "solid", "#C5D9F1");
        this.configureAlignmentCell(cellValueTotal, "center", "middle", false);
        this.configureFontStyleCell(cellValueTotal, true, true, 12, "");
        this.configureBorderCell(cellValueTotal, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
    }

    /**
     * Phương thức hiển thị câu hỏi và loại câu hỏi
     *
     * @param { ExcelJS.Worksheet } worksheet
     *
     * @param { Object } question
     * @param {Number} question.idQuestion - ID câu hỏi
     * @param {String} question.questionText - Nội dung câu hỏi
     * @param {String} question.valueQuestion - Giá trị lựa chọn đối với câu hỏi loại (CheckBox, Radio)
     * @param {String} question.typeQuestion - Loại câu hỏi (CheckBox, Radio, Text, Point, Star)
     * @param {Array<Object>} question.answerUserApplyList[] - Danh sách trả lời câu hỏi
     *
     */
    configureRenderQuestion(worksheet, question) {
        const cellQuestion = worksheet.getCell("A7");
        const cellTypeQuestion = worksheet.getCell("A8");

        worksheet.mergeCells("A7:D7");
        worksheet.mergeCells("A8:D8");

        this.addDataCell(cellQuestion, `Câu hỏi: ${question.questionText}`);
        this.configureFontStyleCell(cellQuestion, true, true, 14, "#000000");

        this.addDataCell(cellTypeQuestion, `Loại: ${this.parseTypeQuestion(question.typeQuestion)}`);
        this.configureFontStyleCell(cellTypeQuestion, true, true, 14, "#000000");
    }

    parseTypeQuestion(type) {
        switch (type) {
            case "CheckBox":
                return "Hộp kiểm";
            case "Radio":
                return "Trắc nghiệm";
            case "Star":
                return "Đánh giá";
            case "Point":
                return "Điểm";
            case "Text":
                return "Văn bản";
        }
    }

    // Hàm cấu hình cell cho dữ liệu
    configureDataCell(cell) {
        this.configureAlignmentCell(cell, "center", "middle", false);
        this.configureFontStyleCell(cell, false, false, 12, "");
        this.configureBorderCell(cell, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
    }

    configureDataCellName(cell) {
        this.configureAlignmentCell(cell, "left", "middle", false);
        this.configureFontStyleCell(cell, false, false, 12, "");
        this.configureBorderCell(cell, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#000000"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: "#000000"}
        });
    }

    // Hàm cấu hình header cell (không thay đổi)
    configureHeaderCell(cell, index, lastIndex, text) {
        cell.value = text;
        this.configureFontStyleCell(cell, true, false, 12, "");
        this.configureAlignmentCell(cell, "center", "middle", false);
        this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
        this.configureBorderCell(cell, {
            top: {style: "thin", color: "#000000"},
            left: {style: "thin", color: "#FFFFFF"},
            bottom: {style: "thin", color: index === lastIndex ? "#FFFFFF" : "#000000"},
            right: {style: "thin", color: index === lastIndex ? "#000000" : "#FFFFFF"}
        });
    }


    normalizeKey(key) {
        return key
            .normalize("NFD") // Chuẩn hóa Unicode
            .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu
            .replace(/\s+/g, "_"); // Thay khoảng trắng bằng "_"
    }

    // Hàm cấu hình cell cho các lựa chọn (không thay đổi)
    configureChoiceCell(cell, index, lastIndex) {
        this.configureAlignmentCell(cell, "center", "middle", false);
        this.configureFontStyleCell(cell, true, false, 12, "");
        this.configureFillCell(cell, "pattern", "solid", "#B7DEE8");
        this.configureBorderCell(cell, {
            top: {style: "thin", color: "#FFFFFF"},
            left: {style: "thin", color: "#FFFFFF"},
            bottom: {style: "thin", color: "#000000"},
            right: {style: "thin", color: index === lastIndex ? "#000000" : "#FFFFFF"}
        });
    }

    formatDataUserAnswerQuestionChoice(apply, answers) {
        // Tạo mảng kết quả mới với định dạng yêu cầu
        return apply.map((userApply, index) => {
            // Tìm phần tử tương ứng trong array2
            const matchingAnswer = answers.find(userAnswer =>
                userAnswer.userApplyResponse.idUser === userApply.idUser &&
                userAnswer.userApplyResponse.typeUser === userApply.typeUser
            );

            const newItem = {
                index: index + 1, // Đánh số thứ tự (bắt đầu từ 1)
                name: userApply.nameUserApply,
                type: userApply.typeUser === "kids" ? "Học sinh" : "Nhân viên"
            };

            // Nếu có phần tử khớp trong array2, thêm key là giá trị answerText
            if (matchingAnswer) {
                const valueAnswer = matchingAnswer.answerText.split(";");

                valueAnswer.forEach((item) => {
                    newItem[this.normalizeKey(item)] = 1;
                })
            }

            return newItem;
        });
    }

    formatDataUserAnswerQuestionText(apply, answers) {
        // Tạo mảng kết quả mới với định dạng yêu cầu
        return apply.map((userApply, index) => {
            // Tìm phần tử tương ứng trong array2
            const matchingAnswer = answers.find(userAnswer =>
                userAnswer.userApplyResponse.idUser === userApply.idUser &&
                userAnswer.userApplyResponse.typeUser === userApply.typeUser
            );

            return {
                index: index + 1, // Đánh số thứ tự (bắt đầu từ 1)
                name: userApply.nameUserApply,
                type: userApply.typeUser === "kids" ? "Học sinh" : "Nhân viên",
                answer: matchingAnswer ? matchingAnswer.answerText : ""
            };
        });
    }

    formatDataGeneralAnswerQuestionText(apply, answers) {
        // Tạo mảng kết quả mới với định dạng yêu cầu
        return apply.map((userApply) => {
            // Tìm phần tử tương ứng trong array2
            const matchingAnswer = answers.find(userAnswer =>
                userAnswer.userApplyResponse.idUser === userApply.idUser &&
                userAnswer.userApplyResponse.typeUser === userApply.typeUser
            );

            return {
                name: userApply.nameUserApply,
                type: userApply.typeUser,
                answer: matchingAnswer ? matchingAnswer.answerText : ""
            };
        });
    }

    formatDataUserAnswerQuestionPoint(apply, answers) {
        // Tạo mảng kết quả mới với định dạng yêu cầu
        return apply.map((userApply, index) => {
            // Tìm phần tử tương ứng trong array2
            const matchingAnswer = answers.find(userAnswer =>
                userAnswer.userApplyResponse.idUser === userApply.idUser &&
                userAnswer.userApplyResponse.typeUser === userApply.typeUser
            );

            return {
                index: index + 1, // Đánh số thứ tự (bắt đầu từ 1)
                name: userApply.nameUserApply,
                type: userApply.typeUser === "kids" ? "Học sinh" : "Nhân viên",
                point: matchingAnswer ? matchingAnswer.answerText + "/10" : ""
            };
        });
    }

    /**
     *
     * @param { Array<Object> } apply - Danh sách áp dụng trả lời
     * @param {Number} apply[].idUser - id người được áp dụng
     * @param {String} apply[].typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} apply[].nameUserApply - Tên người được áp dụng
     * @param {String} apply[].classNameKis - Tên lớp đối với học sinh (kids)
     * @param {Boolean} apply[].answer - Nguời áp dụng đã trả lời phiếu hay chưa?
     * @param {Array<Object>} apply[].departmentTeacherApplyList - Danh sách phòng ban đối với nhân sự (type: teacher)
     * @param {Number} apply.departmentTeacherApplyList.idDepartment - ID phòng ban
     * @param {String} apply.departmentTeacherApplyList.departmentName - Tên phòng ban
     *
     * @param {Array<Object>} answers - Danh sách trả lời câu hỏi
     * @param {Object} answers.userApplyResponse - Thông tin người trả lời
     * @param {Number} answers.userApplyResponse.idUser - ID nguời trả lời
     * @param {String} answers.userApplyResponse.typeUser - Học sinh / Nhân sự (kids / teacher)
     * @param {String} answers.userApplyResponse.nameUserApply - Tên người trả lời
     * @param {String} answers.userApplyResponse.classNameKids - Tên lớp (type: kids)
     * @param {Boolean} answers.userApplyResponse.answer - Đã trả lời phiếu chưa?
     * @param {Array<Object>} answers.userApplyResponse.departmentTeacherApplyList - Danh sách phòng ban (type: teacher)
     * @param {Number} answers.userApplyResponse.departmentTeacherApplyList.idDepartment - ID phòng
     * @param {String} answers.userApplyResponse.departmentTeacherApplyList.departmentName - Tên phòng ban
     * @param {String} answers.answerText - Câu trả lời
     * @returns {*}
     */
    formatDataUserAnswerQuestionStar(apply, answers) {
        // Tạo mảng kết quả mới với định dạng yêu cầu
        return apply.map((userApply, index) => {
            // Tìm phần tử tương ứng trong array2
            const matchingAnswer = answers.find(userAnswer =>
                userAnswer.userApplyResponse.idUser === userApply.idUser &&
                userAnswer.userApplyResponse.typeUser === userApply.typeUser
            );

            return {
                index: index + 1, // Đánh số thứ tự (bắt đầu từ 1)
                name: userApply.nameUserApply,
                type: userApply.typeUser === "kids" ? "Học sinh" : "Nhân viên",
                star: matchingAnswer ? '★'.repeat(parseInt(matchingAnswer.answerText)) + '☆'.repeat(5 - parseInt(matchingAnswer.answerText)) : ""
            };
        });
    }

    /**
     * Phương thức tạo phần thông tin chung ở mỗi sheet
     *
     * @param {ExcelJS.Worksheet} worksheet
     * @param {Object} data - Thông tin tiêu đề chung sheet (headerSheet)
     * @param {String} data.nameSchool - Tên trường
     * @param {String} data.nameForm - Tên phiếu khảo sát
     * @param {String} data.surveyForm - Thời gian áp dụng của phiếu
     * @param {String} data.nameUserCreate - Người tạo phiếu
     */
    configureHeaderSheet(worksheet, data) {
        Object.keys(data).forEach((key, index) => {
            const cell = worksheet.getCell(`A${index + 1}`);
            switch (key) {
                case 'nameSchool':
                    worksheet.mergeCells(`A${index + 1}:C${index + 1}`);
                    this.configureHeightRow(worksheet, index + 1, 20);
                    this.addDataCell(cell, `Trường: ${data[key]}`);
                    this.configureFontStyleCell(cell, true, false, 14, '');
                    this.configureBorderCell(cell, {
                        right: {style: "medium", color: "#78a5e7"},
                    })

                    break;
                case "nameForm":
                    worksheet.mergeCells(`A${index + 1}:C${index + 1}`);
                    this.addDataCell(cell, `Tên phiếu: ${data[key]}`);
                    this.configureHeightRow(worksheet, index + 1, 20);
                    this.configureFontStyleCell(cell, true, false, 12, '');
                    this.configureBorderCell(cell, {
                        right: {style: "medium", color: "#78a5e7"},
                    })

                    break;
                case "surveyTime":
                    worksheet.mergeCells(`A${index + 1}:C${index + 1}`);
                    this.addDataCell(cell, `Thời gian áp dụng: ${data[key] === "" ? "" : data[key]}`);
                    this.configureHeightRow(worksheet, index + 1, 20);
                    this.configureFontStyleCell(cell, true, false, 12, '');
                    this.configureBorderCell(cell, {
                        right: {style: "medium", color: "#78a5e7"},
                    })

                    break;
                case "nameUserCreate":
                    worksheet.mergeCells(`A${index + 1}:C${index + 1}`);
                    this.addDataCell(cell, `Người tạo: ${data[key]}`);
                    this.configureHeightRow(worksheet, index + 1, 20);
                    this.configureFontStyleCell(cell, true, false, 12, '');
                    this.configureBorderCell(cell, {
                        bottom: {style: "medium", color: "#78a5e7"},
                        right: {style: "medium", color: "#78a5e7"},
                    })
                    break;
            }
            this.configureAlignmentCell(cell, 'left', 'middle', false);
        })
    }

    /**
     * Phương thức chỉnh độ rộng cột trong sheet
     *
     * @param { ExcelJS.Worksheet } worksheet
     * @param { Number } indexColumn - STT cột trong file excel
     * @param { Number } width - Chiều dài cột
     */
    configureWidthColumn(worksheet, indexColumn, width) {
        worksheet.getColumn(indexColumn).width = width;
    }

    /**
     *
     * @param { ExcelJS.Worksheet} worksheet
     * @param { Number } indexRow - STT dòng trong sheet
     * @param { Number } height - Chiều cao dòng
     */
    configureHeightRow(worksheet, indexRow, height) {
        worksheet.getRow(indexRow).height = height;
    }

    configureFillCell(cell, type, pattern, color) {
        cell.fill = {
            type: type,
            pattern: pattern,
            fgColor: {
                argb: color === '' ? this.hexToArgb("#FFFFFF") : this.hexToArgb(color)
            }
        };
    }

    configureFontStyleCell(cell, bold, italic, size, color) {
        cell.font = {
            bold: bold,
            italic: italic,
            size: size,
            color: {
                argb: color === '' ? this.hexToArgb("#000000") : this.hexToArgb(color)
            }
        }
    }

    configureAlignmentCell(cell, horizontal, vertical, wrapText) {
        cell.alignment = {
            horizontal: horizontal,
            vertical: vertical,
            wrapText: wrapText
        };
    }

    configureBorderCell(cell, borders) {
        cell.border = {};

        if (borders.top) {
            cell.border.top = {
                style: borders.top.style,
                color: {argb: this.hexToArgb(borders.top.color)}
            };
        }

        if (borders.left) {
            cell.border.left = {
                style: borders.left.style,
                color: {argb: this.hexToArgb(borders.left.color)}
            };
        }

        if (borders.bottom) {
            cell.border.bottom = {
                style: borders.bottom.style,
                color: {argb: this.hexToArgb(borders.bottom.color)}
            };
        }

        if (borders.right) {
            cell.border.right = {
                style: borders.right.style,
                color: {argb: this.hexToArgb(borders.right.color)}
            };
        }
    }

    addDataCell(cell, data) {
        cell.value = data;
    }

    hexToArgb(hex) {
        // Xóa dấu "#" nếu có
        hex = hex.replace('#', '');
        // Mặc định alpha là "FF" (không trong suốt)
        return `FF${hex.toUpperCase()}`;
    }

   sanitizeWorksheetName(name) {
        // Loại bỏ các ký tự không hợp lệ
        return name.replace(/[*?:\\/[\]]/g, '');
    }
}

export default new ExcelStatisticalSurveyForm();